import { render, staticRenderFns } from "./CartResumeAdditionalOptionCard.vue?vue&type=template&id=98887ea2&"
import script from "./CartResumeAdditionalOptionCard.vue?vue&type=script&lang=js&"
export * from "./CartResumeAdditionalOptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports